<template>
  <div class="search-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SearchGroup'
}
</script>

<style scoped>
  .search-group >>> .search-item:not(:last-child) {
    margin-right: 15px;
  }

  .search-group >>> .search-item {
    margin-bottom: 5px;
  }
</style>
